import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Container = styled.div`
    position: relative;
    cursor: pointer;

    .react-datepicker-popper {
        z-index: 9999 !important;
    }
`;